<template>
  <section class="patient-form">
    <span id="book-time-form-anchor"></span>
    <div
      class="book-time-form-wrapper nk-form-wrapper clearfix margin-top-md-4 padding-top-xs-2"
      v-if="selectedSlot"
      id="book-time-form"
    >
      <div class="col-xs-12 col-md-4">
        <div
          class="patient-form-left-column"
          :class="{ 'booking-not-completed': !booking.completed }"
        >
          <h2
            class="hidden-xs hidden-sm visible-md visible-lg margin-top-xs-0"
            v-if="!booking.completed"
          >
            Din bokning
          </h2>

          <div v-if="booking.completed">
            <h2 class="margin-top-xs-0">Din bokning är genomförd!</h2>
          </div>
          <BookingDetails />
          <p v-if="booking.message && !booking.authenticationFailed" v-html="booking.message"></p>
          <div v-if="isMobile && booking.authenticationFailed" class="new-error-message">
            <p>Det gick inte att boka med BankID. Du behöver fylla i ditt förnamn och efternamn för att slutföra bokningen!</p>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-7 col-md-offset-1">
        <div v-if="!booking.completed">
          <masked-input
            v-model="patient.ssn"
            mask="1111-11-11-1111"
            placeholder="ÅÅÅÅ-MM-DD-XXXX"
            class="nk-input margin-bottom-xs-1"
            type="tel"
            @keydown="initiateCheckout"
            :disabled="ui.loading.doingBooking"
            :class="{
              'nk-force-disable': ui.loading.doingBooking,
            }"
            required
          ></masked-input>
          <p class="error-text" v-if="ui.formErrors.ssn">
            <small>Kontrollera ditt personnummer</small>
          </p>
          <p class="error-text" v-if="ui.formErrors.ssnAge">
            <small>Du måste vara minst 18 år för att boka en tid.</small>
          </p>

          <input
            type="email"
            v-model="patient.email"
            placeholder="E-post"
            class="margin-bottom-xs-1"
            :class="{ 'nk-force-disable': ui.loading.doingBooking }"
            :disabled="ui.loading.doingBooking"
            @keydown="initiateCheckout"
            @focus="elementInFocus = 'email'"
            @blur="elementInFocus = false"
            required
          />
          <p
            class="error-text"
            v-if="
              ui.formErrors.email &&
              elementInFocus != 'email' &&
              patient.email.length > 0
            "
          >
            <small>E-posten är inte giltig</small>
          </p>

          <input
            type="tel"
            v-model="patient.phone"
            placeholder="Telefon"
            class="margin-bottom-xs-1"
            :class="{ 'nk-force-disable': ui.loading.doingBooking }"
            :disabled="ui.loading.doingBooking"
            @keydown="initiateCheckout"
            @focus="elementInFocus = 'phone'"
            @blur="elementInFocus = false"
            required
          />
          <p
            class="error-text"
            v-if="
              ui.formErrors.phone &&
              elementInFocus != 'phone' &&
              patient.phone.length > 0
            "
          >
            <small>Telefonnumret är inte giltigt</small>
          </p>

					<input
						id="patient-firstname"
            v-if="booking.authenticationFailed && isMobile"
						type="text"
						v-model="patient.firstName"
						placeholder="Ditt förnamn"
						class="margin-bottom-xs-1"
						@keydown="initiateCheckout"
						required
					/>
					<input
						type="text"
            v-if="booking.authenticationFailed && isMobile"
						v-model="patient.lastName"
						placeholder="Ditt efternamn"
						class="margin-bottom-xs-1"
						@keydown="initiateCheckout"
						required
					/>
          <div class="margin-bottom-xs-1">
            <span class="wpcf7-form-control-wrap gdpr_consent"
              ><span class="wpcf7-form-control wpcf7-acceptance"
                ><span class="wpcf7-list-item"
                  ><label
                    for="gdpr_consent"
                    :class="{
                      'nk-force-disable': ui.loading.doingBooking,
                    }"
                    ><input
                      type="checkbox"
                      name="gdpr_consent"
                      v-model="patient.gdprConsent"
                      value="gdpr_consent"
                      :disabled="ui.loading.doingBooking"
                      :class="{
                        'nk-force-disable': ui.loading.doingBooking,
                      }"
                      required
                    /><span
                      class="wpcf7-list-item-label"
                      @click="patient.gdprConsent = !patient.gdprConsent"
                      ><span class="nk-checkbox-label"
                        ><p>
                          Jag har tagit del av Nordiska Klinikens
                          <a
                            href="/om-oss/integritetspolicy/"
                            class="link-underlined"
                            target="_blank"
                            >Integritetspolicy</a
                          >
                          gällande hantering av personuppgifter.
                        </p></span
                      ></span
                    ></label
                  ></span
                ></span
              ></span
            >
          </div>

          <div class="margin-bottom-xs-1">
            <span class="wpcf7-form-control-wrap newsletter_signup"
              ><span class="wpcf7-form-control wpcf7-acceptance"
                ><span class="wpcf7-list-item"
                  ><label
                    for="newsletter_signup"
                    :class="{
                      'nk-force-disable': ui.loading.doingBooking,
                    }"
                    ><input
                      type="checkbox"
                      name="newsletter_signup"
                      :class="{
                        'nk-force-disable': ui.loading.doingBooking,
                      }"
                      v-model="patient.newsletterSignup"
                      value="1"
                      required
                      :disabled="ui.loading.doingBooking"
                    /><span
                      class="wpcf7-list-item-label"
                      @click="
                        patient.newsletterSignup = !patient.newsletterSignup
                      "
                      ><span class="nk-checkbox-label"
                        ><p>
                          Jag vill anmäla mig till Nordiska Klinikens nyhetsbrev
                          och få information om nyheter, exklusiva erbjudanden
                          och behandlingar.
                        </p></span
                      ></span
                    ></label
                  ></span
                ></span
              ></span
            >
          </div>

          <div class="">
            <!--
						<a
							href="#"
							class="nk-button link-arrow-right"
							:class="{
								'nk-button-inactive': !formIsValid,
								'nk-button-disabled': !formIsValid,
							}"
							@click.prevent="testAddBooking()"
							v-if="!ui.loading.doingBooking"
							>Boka tid</a
						>
                        -->

            <div
              class="booking-buttons-wrapper"
              v-if="!ui.loading.doingBooking"
            >
              <div v-if="isMobile && !booking.authenticationFailed">
                <a
                  href="#"
                  class="nk-button nk-button-primary nk-btn-bankid"
                  :class="{
                    'nk-button-inactive': !formIsValid,
                    'nk-button-disabled': !formIsValid,
                  }"
                  @click.prevent="startBankIDBooking('sameDevice')"
                  v-if="!ui.loading.doingBooking"
                  >Boka med BankID på samma enhet
                  <svg
                    class="btn-bankid-logo"
                    xmlns="http://www.w3.org/2000/svg"
                    width="169"
                    height="158"
                    viewBox="0 0 169 158"
                  >
                    <g fill="none" fill-rule="evenodd">
                      <g fill="#183E4F">
                        <g>
                          <path
                            d="M45.916 135.23c5.268 0 9.905 2.083 9.015 7.63l-1.005 6.257c-.355 2.211-.289 2.873 2.253 2.922l-2.583 5.878c-4.495.291-6.67-.167-7.75-2.046-2.384 1.422-5.006 2.129-7.814 2.129-5.093 0-6.845-2.541-6.392-5.378.213-1.34 1.03-2.67 2.328-3.756 2.794-2.336 9.715-2.673 12.42-4.462.236-2.002-.6-2.712-3.15-2.712-2.979 0-5.466.961-9.714 3.754l1.035-6.47c3.698-2.58 7.251-3.747 11.357-3.747zm32.032 0c4.892 0 7.172 3.008 6.407 7.968L82.075 158h-8.773l1.889-12.256c.342-2.244-.3-3.266-2.028-3.266-1.392 0-2.649.764-3.872 2.414L67.27 158H58.5l3.446-22.395h8.774l-.452 2.929c2.772-2.376 4.896-3.305 7.68-3.305zm22.058-7.436l-2.19 14.881 8.377-8.065H117l-10.759 9.971L114.866 158h-10.973l-6.656-10.808h-.082L95.567 158H86.82l4.438-30.206h8.747zm-78.437.93c7.265 0 9.048 3.578 8.525 6.855-.423 2.664-2.276 4.617-5.514 5.906 4.08 1.496 5.669 3.863 5.084 7.52-.733 4.616-4.87 8.066-10.257 8.066H0l4.514-28.347h17.055zm131.362 0c11.337 0 14.611 7.98 13.563 14.547-1.03 6.442-6.288 13.8-16.25 13.8h-16.53l4.532-28.347h14.685zm-19.681 0l-4.553 28.347h-10.304l4.554-28.347h10.303zm-87.452 19.348c-2.392 1.462-6.8 1.21-7.281 4.213-.228 1.42.685 2.46 2.151 2.46 1.427 0 3.164-.583 4.517-1.5-.091-.498-.047-1.042.113-2.043l.5-3.13zm-30.297-3.262h-3.332l-1.265 7.938h3.076c3.421 0 5.43-1.33 5.872-4.115.38-2.37-1.017-3.823-4.351-3.823zm134.677-9.357h-2.75l-2.379 14.884h2.707c4.978 0 7.721-2.37 8.535-7.439.595-3.741-.573-7.445-6.113-7.445zm-133.187-2.41h-2.95l-1.185 7.44h2.95c3.334 0 4.889-1.704 5.212-3.74.344-2.158-.692-3.7-4.027-3.7zM43.87 14.405c3.239 0 5.74.667 7.04 1.88.907.849 1.245 1.96.977 3.219-.26 1.215-1.64 2.797-3.71 4.223-5.866 4.066-4.85 8.28-4.397 9.477 1.358 3.601 5.892 5.544 9.462 5.544h7.58l-7.07 43.956h.121c-2.632 16.426-4.59 28.813-4.953 31.148H6.964c.804-5.165 11.305-70.804 11.97-75.091h.645l2.179.005h.502l1.696.004.446.001.62.001h.371l.172.001.451.001h.504l.058.001h.076c5.043-.027 9.69-2.3 11.844-5.793 2.106-3.388 1.305-7.02-2.076-9.482-1.127-.818-2.424-2.145-2.17-3.787.348-2.217 4.171-5.308 9.617-5.308zM109.119 0c38.623 0 65.555 16.776 58.858 58.635-5.415 33.793-32.973 55.218-66.709 55.218H93.27l5.425-34.104c13.664-.152 25.113-6.51 27.478-21.265 2.54-15.881-5.526-22.699-20.537-22.815.003-.024.003-.037.003-.037h-11.04c-2.542 0-5.808-1.395-6.655-3.641-.264-.696-.802-3.206 3.314-6.068 1.58-1.101 4.324-3.347 4.9-6.034.471-2.252-.198-4.429-1.845-5.967-1.876-1.757-5.01-2.69-9.061-2.69-6.765 0-11.939 4.042-12.527 7.813-.037.245-.061.532-.061.846 0 1.5.59 3.709 3.397 5.763 1.03.753 2.028 1.86 2.028 3.341 0 .679-.21 1.43-.723 2.267-1.608 2.612-5.341 4.378-9.301 4.4l-7.243-.017L66.526 0z"
                            transform="translate(-100 -239) translate(100 239)"
                          />
                        </g>
                      </g>
                    </g></svg
                ></a>
              </div>
              <div v-if="isMobile && booking.authenticationFailed" class="new-error-message">
					      <p>Det gick inte att boka med BankID. Du behöver fylla i ditt förnamn och efternamn för att slutföra bokningen!</p>
              </div>
                <a
                  href="#"
                  class="nk-button nk-button-primary nk-btn-bankid"
                  :class="{
                    'nk-button-inactive': !formIsValid,
                    'nk-button-disabled': !formIsValid,
                  }"
							    @click.prevent="testAddBooking()"
                  v-if="!ui.loading.doingBooking && booking.authenticationFailed"
                  >Boka utan BankID</a>
              <div v-if="!isMobile" class="nk-qr-wrapper">
                <div v-if="!booking.waitingForSign">
                  <a
                    href="#"
                    class="nk-button nk-button-primary nk-btn-bankid"
                    :class="{
                      'nk-button-inactive': !formIsValid,
                      'nk-button-disabled': !formIsValid,
                    }"
                    @click.prevent="authenticate('otherDevice')"
                    v-if="!booking.qrCode"
                    >Boka med BankID
                    <svg
                      class="btn-bankid-logo"
                      xmlns="http://www.w3.org/2000/svg"
                      width="169"
                      height="158"
                      viewBox="0 0 169 158"
                    >
                      <g fill="none" fill-rule="evenodd">
                        <g fill="#183E4F">
                          <g>
                            <path
                              d="M45.916 135.23c5.268 0 9.905 2.083 9.015 7.63l-1.005 6.257c-.355 2.211-.289 2.873 2.253 2.922l-2.583 5.878c-4.495.291-6.67-.167-7.75-2.046-2.384 1.422-5.006 2.129-7.814 2.129-5.093 0-6.845-2.541-6.392-5.378.213-1.34 1.03-2.67 2.328-3.756 2.794-2.336 9.715-2.673 12.42-4.462.236-2.002-.6-2.712-3.15-2.712-2.979 0-5.466.961-9.714 3.754l1.035-6.47c3.698-2.58 7.251-3.747 11.357-3.747zm32.032 0c4.892 0 7.172 3.008 6.407 7.968L82.075 158h-8.773l1.889-12.256c.342-2.244-.3-3.266-2.028-3.266-1.392 0-2.649.764-3.872 2.414L67.27 158H58.5l3.446-22.395h8.774l-.452 2.929c2.772-2.376 4.896-3.305 7.68-3.305zm22.058-7.436l-2.19 14.881 8.377-8.065H117l-10.759 9.971L114.866 158h-10.973l-6.656-10.808h-.082L95.567 158H86.82l4.438-30.206h8.747zm-78.437.93c7.265 0 9.048 3.578 8.525 6.855-.423 2.664-2.276 4.617-5.514 5.906 4.08 1.496 5.669 3.863 5.084 7.52-.733 4.616-4.87 8.066-10.257 8.066H0l4.514-28.347h17.055zm131.362 0c11.337 0 14.611 7.98 13.563 14.547-1.03 6.442-6.288 13.8-16.25 13.8h-16.53l4.532-28.347h14.685zm-19.681 0l-4.553 28.347h-10.304l4.554-28.347h10.303zm-87.452 19.348c-2.392 1.462-6.8 1.21-7.281 4.213-.228 1.42.685 2.46 2.151 2.46 1.427 0 3.164-.583 4.517-1.5-.091-.498-.047-1.042.113-2.043l.5-3.13zm-30.297-3.262h-3.332l-1.265 7.938h3.076c3.421 0 5.43-1.33 5.872-4.115.38-2.37-1.017-3.823-4.351-3.823zm134.677-9.357h-2.75l-2.379 14.884h2.707c4.978 0 7.721-2.37 8.535-7.439.595-3.741-.573-7.445-6.113-7.445zm-133.187-2.41h-2.95l-1.185 7.44h2.95c3.334 0 4.889-1.704 5.212-3.74.344-2.158-.692-3.7-4.027-3.7zM43.87 14.405c3.239 0 5.74.667 7.04 1.88.907.849 1.245 1.96.977 3.219-.26 1.215-1.64 2.797-3.71 4.223-5.866 4.066-4.85 8.28-4.397 9.477 1.358 3.601 5.892 5.544 9.462 5.544h7.58l-7.07 43.956h.121c-2.632 16.426-4.59 28.813-4.953 31.148H6.964c.804-5.165 11.305-70.804 11.97-75.091h.645l2.179.005h.502l1.696.004.446.001.62.001h.371l.172.001.451.001h.504l.058.001h.076c5.043-.027 9.69-2.3 11.844-5.793 2.106-3.388 1.305-7.02-2.076-9.482-1.127-.818-2.424-2.145-2.17-3.787.348-2.217 4.171-5.308 9.617-5.308zM109.119 0c38.623 0 65.555 16.776 58.858 58.635-5.415 33.793-32.973 55.218-66.709 55.218H93.27l5.425-34.104c13.664-.152 25.113-6.51 27.478-21.265 2.54-15.881-5.526-22.699-20.537-22.815.003-.024.003-.037.003-.037h-11.04c-2.542 0-5.808-1.395-6.655-3.641-.264-.696-.802-3.206 3.314-6.068 1.58-1.101 4.324-3.347 4.9-6.034.471-2.252-.198-4.429-1.845-5.967-1.876-1.757-5.01-2.69-9.061-2.69-6.765 0-11.939 4.042-12.527 7.813-.037.245-.061.532-.061.846 0 1.5.59 3.709 3.397 5.763 1.03.753 2.028 1.86 2.028 3.341 0 .679-.21 1.43-.723 2.267-1.608 2.612-5.341 4.378-9.301 4.4l-7.243-.017L66.526 0z"
                              transform="translate(-100 -239) translate(100 239)"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </a>
                </div>
                <div v-id="!booking.waitingForSign">
                  <div v-if="booking.qrCode" class="nk-qr">
                    <img :src="booking.qrCode" v-bind:alt="pic" />
                    <span>1. Öppna BankID-appen</span>
                    <span>2. Välj "Scanna QR-kod"</span>
                    <span>3. Scanna QR-koden</span>
                    <span>4. Legitimera dig</span>
                  </div>
                </div>
                <div v-if="booking.waitingForSign" class="nk-waiting-sign">
                  <span
                    >Skriv in din kod eller identifiera med Face ID i
                    BankID-appen</span
                  >
                </div>
              </div>
            </div>

            <div class="bank-id-signing-message">
              <p v-if="isSigningBankIDOnOtherDevice">
                Öppna BankID-appen på din andra enhet och signera. Stäng inte
                det här fönstret och återvänd till den här sidan efter signering
                för att slutföra bokningen.
              </p>
              <p v-if="isSigningBankIDOnSameDevice">
                Försöker öppna BankID-appen automatiskt.
                <span v-if="getAutostartUrl">
                  Om appen inte öppnas automatiskt kan du
                  <a :href="getAutostartUrl" class="link-underlined"
                    >klicka här för att öppna BankID-appen</a
                  >.</span
                >
              </p>
              <p v-if="ui.loading.doingBooking">
                <a
                  class="link-underlined"
                  href="#"
                  @click.prevent="cancelBankIDOrder()"
                  >Avbryt BankID-signering</a
                >
              </p>
            </div>
            <img
              class="loading-spinner loading-spinner-left margin-top-xs-1 margin-top-md-0"
              src="/wp-content/themes/nordiskakliniken/dist/images/loading-spinner.svg"
              v-if="ui.loading.doingBooking"
            />
          </div>

          <p
            class="margin-top-xs-1"
            v-if="booking.message"
            v-html="booking.message"
          ></p>

          <p class="margin-top-xs-1">
            Saknar du BankID?
            <a href="/kontakt/" target="_blank" class="link-underlined"
              >Kontakta oss</a
            >
            för bokning.
          </p>
        </div>

        <div
          class="booking-confirmation-details margin-bottom-xs-2"
          v-if="booking.completed"
        >
          <p>
            <a
              href="#"
              @click.prevent="prepareNewBooking()"
              class="link-underlined"
              >Klicka här för att boka en ny tid.</a
            >
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import BookingDetails from "./BookingDetails.vue";
import MaskedInput from "vue-masked-input";

export default {
  components: {
    MaskedInput,
    BookingDetails,
  },
  data() {
    return {
      elementInFocus: false, // Keep track of which input element is in focus in order to display/not display error messages
    };
  },
  computed: {
    ...mapState([
      "activityGroups",
      "activities",
      "providers",
      "selectedSlot",
      "dates",
      "ui",
      "booking",
      "patient",
    ]),
    ...mapGetters([
      "dateIsInThePast",
      "activityIsCampaign",
      "formatProviderName",
      "selectedSlotFormated",
      "formIsValid",
      "noAvailableTimesForWeek",
      "isSigningBankIDOnOtherDevice",
      "isSigningBankIDOnSameDevice",
      "isMobile",
      "getAutostartUrl",
      "getQrCode",
    ]),
  },
  methods: {
    ...mapActions([
      "setActivityGroup",
      "setActivity",
      "setupActiveDates",
      "setSelectedSlot",
      "setProvider",
      "getRealWeekday",
      "setModalState",
      "handleSwipe",
      "prepareNewBooking",
      "shouldDeselectTimeslot",
      "testAddBooking",
      "fakeCompleteBooking",
      "initiateCheckout",
      "startBankIDBooking",
      "authenticate",
      "collectBankID",
      "cancelBankIDOrder",
    ]),
  },
};
</script>
